import React from 'react';
import * as PropTypes from 'prop-types';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import { SubjectPropType } from '../../abilities/proptypes';
import { UPDATE } from '../../abilities/actions';
import IconButton from './IconButton';

const RestoreIconButton = ({ onClick, size, disabled, subject }) => (
    <IconButton onClick={onClick} size={size} disabled={disabled} subject={subject} action={UPDATE}>
        <UnarchiveIcon />
    </IconButton>
);

RestoreIconButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    size: PropTypes.string,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
};

RestoreIconButton.defaultProps = {
    size: null,
    disabled: false,
    subject: null,
};

export default RestoreIconButton;
